import { z } from 'zod';
import { IsoDateTimeSchema, UuidSchema } from './common.js';

export const TaskStatusSchema = z.enum(['open', 'in_progress', 'done']);
export type TaskStatus = z.infer<typeof TaskStatusSchema>;

export const TaskSchema = z.object({
  task_id: UuidSchema,
  project_id: UuidSchema,
  title: z.string().min(1),
  owner_user_id: UuidSchema.optional(),
  status: TaskStatusSchema.default('open'),
  due_date: IsoDateTimeSchema.optional(),
  description: z.string().optional(),
  created_at: IsoDateTimeSchema,
  created_by: UuidSchema.optional(),
  updated_at: IsoDateTimeSchema,
});
export type Task = z.infer<typeof TaskSchema>;

export const CreateTaskInputSchema = TaskSchema.omit({
  task_id: true,
  created_at: true,
  updated_at: true,
});
export type CreateTaskInput = z.infer<typeof CreateTaskInputSchema>;

export const UpdateTaskInputSchema = TaskSchema.partial().required({
  task_id: true,
});
export type UpdateTaskInput = z.infer<typeof UpdateTaskInputSchema>;
